import { CustomersResponseModel } from "../management-pages/shared/model/customers-response.model";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getMyBalance() {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(`${API_URL}/current/balance`, authorizationHeader);
  } catch (error) {
    console.error(error);
  }
}

async function getBalance(userId: number) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/balance/${userId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function validateBalance(
  paymentId: string,
  paymentTypeId: number,
  paymentMethod: number,
  currency: number,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    const data = {
      paymentId: paymentId,
      paymentTypeId: paymentTypeId,
      paymentMethod: paymentMethod,
      currency: currency,
    };

    return axiosInstance.post(
      `${API_URL}/validate/balance`,
      data,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function getBindings() {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(`${API_URL}/bindings`, authorizationHeader);
  } catch (error) {
    console.error(error);
  }
}

async function refill(userId: number, amount: number, reason: string) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/refill-balance`,
        { userId, amount, reason },
        authorizationHeader,
      )
      .then((response) => {
        return response?.data as CustomersResponseModel;
      });
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getMyBalance,
  getBalance,
  validateBalance,
  getBindings,
  refill,
};
